import styled from "styled-components";

export const PrivateTheatreCont = styled.div`
  background-color: purple;
  border-radius: 20px;
  display: flex;
  width: 100%;
  max-width: 1200px;
  margin: 4rem auto;
  padding: 1rem;

  @media only screen and (max-width: 1020px) {
    flex-direction: column;
  }
`;

export const LeftSection = styled.div`
  flex: 3;
  display: flex;
  justify-content: center;
  align-items: center;
  color: white;
  background-color: purple;
  border-radius: 20px;
  padding: 1rem;

  .text {
    text-align: left;
    font-size: 1.5rem;
    font-weight: 700;
  }
`;

export const RightSection = styled.div`
  flex: 5;
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 1rem;

  .title {
    font-size: 1.2rem;
    color: #d8d3d3;
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  .desc {
    font-size: 0.875rem;
    color: #d8d3d3;
  }

  @media(max-width: 1020px){
    grid-template-columns: 1fr
  }
`;

export const Card = styled.div`
  padding: 1rem;
  text-align: left;
  transition: transform 0.3s ease-in-out;
  display: flex;
  gap: 1rem;
`;

export const Icon = styled.div`
  width: 70px;
  height: 70px;
  border-radius: 50%;
  background-color: white;
  color: purple;
  font-size: 2rem;
  margin-bottom: 0.5rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;
